/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Scanner_Unauthorized_DescInputs */

const en_verify_scanner_unauthorized_desc = /** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be logged into an authorized Team Account to scan tickets for this event.`)
};

const es_verify_scanner_unauthorized_desc = /** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes estar conectado a una Cuenta de Equipo autorizada para escanear tickets de este evento.`)
};

const fr_verify_scanner_unauthorized_desc = /** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez être connecté à un compte d'équipe autorisé pour scanner les tickets de cet événement.`)
};

const de_verify_scanner_unauthorized_desc = /** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du musst in einem autorisierten Team-Konto angemeldet sein, um Tickets für dieses Event zu scannen.`)
};

const id_verify_scanner_unauthorized_desc = /** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda harus masuk ke Akun Tim resmi untuk memindai tiket acara ini.`)
};

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const ja_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const zh_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const ar_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const it_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const ru_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const pt_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/** @type {(inputs: Verify_Scanner_Unauthorized_DescInputs) => LocalizedString} */
const ko_verify_scanner_unauthorized_desc = en_verify_scanner_unauthorized_desc;

/**
* | output |
* | --- |
* | "You must be logged into an authorized Team Account to scan tickets for this event." |
*
* @param {Verify_Scanner_Unauthorized_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_scanner_unauthorized_desc = /** @type {((inputs?: Verify_Scanner_Unauthorized_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Scanner_Unauthorized_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_scanner_unauthorized_desc(inputs)
	if (locale === "es") return es_verify_scanner_unauthorized_desc(inputs)
	if (locale === "fr") return fr_verify_scanner_unauthorized_desc(inputs)
	if (locale === "de") return de_verify_scanner_unauthorized_desc(inputs)
	if (locale === "ja") return ja_verify_scanner_unauthorized_desc(inputs)
	if (locale === "zh") return zh_verify_scanner_unauthorized_desc(inputs)
	if (locale === "ar") return ar_verify_scanner_unauthorized_desc(inputs)
	if (locale === "id") return id_verify_scanner_unauthorized_desc(inputs)
	if (locale === "it") return it_verify_scanner_unauthorized_desc(inputs)
	if (locale === "ru") return ru_verify_scanner_unauthorized_desc(inputs)
	if (locale === "pt") return pt_verify_scanner_unauthorized_desc(inputs)
	return ko_verify_scanner_unauthorized_desc(inputs)
});